import { useEffect, useState } from "react";

const list = require('../data/data-demo-sender.json').data;

export default function WebbDemoListModule() {

  const asset="";
  const [data,setData]=useState(list);

  return (
    <>
    <div className="row row-cols-1 row-cols-md-3">

      {data && data.map((item, i) => ( item.actv ?
        
        <div className="col mb-3" key={i}>

          <div class="ratio ratio-16x9 mb-3">
            <iframe 
              src={item.link} 
              title="video" 
              allowfullscreen
              allow="autoplay; fullscreen" 
              className="rounded-wd"
            ></iframe>
          </div>
          <p className="fw-bold m-0 p-0">{item.name}</p>
          <small className="line-clamp-md text-dark">{item.shrt}</small>
        
        </div>
      :''))}
      </div>
    </>
  )
}